import React from 'react';
import PropTypes from 'prop-types';
import PasswordReveal from '@pattern-library/password-reveal';

/**
 * react-debounce-input spreads defaultProps including type="text" onto element.
 * @pattern-library/password-reveal merges that onto &lt;input&gt; last, which
 * overrides its show/hide type toggling — strip forwarded type always.
 */
function PasswordRevealWithoutForwardedType(props) {
    // Omit type from DebounceInput defaults (`text`) or callers (`password`) —
    // PasswordReveal must control type for show/hide.
    const { type, ...forwarded } = props;
    void type;
    return <PasswordReveal {...forwarded} />;
}

PasswordRevealWithoutForwardedType.propTypes = {
    type: PropTypes.string
};

export default PasswordRevealWithoutForwardedType;
